import { UCHI_GRAPHQL_GATEWAY_URL } from '~/shared/lib/env/envVariables';

const mutation = `
  mutation AdminSignIn(
    $login: String!
    $password: String!
    $nextPath: String
  ) {
    adminSignIn(
      input: {
        params: {
          login: $login
          password: $password
          nextPath: $nextPath
        }
      }
    ) {
      payload {
        success
        nextPath
      }
    }
  }
`;

type LoginRequestParams = {
  login: string;
  password: string;
  redirectPath?: string;
};

type LoginRequestResponse = {
  success: boolean;
  error: string | null;
  nextPath: string | null;
};

export async function loginRequest({
  login,
  password,
  redirectPath,
}: LoginRequestParams) {
  const request = {
    query: mutation,
    variables: {
      login,
      password,
      nextPath: redirectPath,
    },
    operationName: 'AdminSignIn',
  };

  const _res: LoginRequestResponse = {
    success: false,
    error: null,
    nextPath: null,
  };

  try {
    const response = await fetch(UCHI_GRAPHQL_GATEWAY_URL, {
      method: 'POST',
      body: JSON.stringify(request),
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    });

    const result = await response.json();

    if (response.ok) {
      if (result.errors?.[0].extensions.error_code === 'VALIDATION_ERROR') {
        _res.error = 'Неверная пара логина и пароля';
      }

      _res.success = !result.errors?.length;

      if (result.data?.adminSignIn?.payload?.nextPath) {
        _res.nextPath = result.data.adminSignIn.payload.nextPath;
      }
    } else {
      _res.error = 'Неизвестная ошибка';
    }
  } catch (error) {
    _res.error = 'Неизвестная ошибка';
  }

  return _res;
}
